import { Flex } from '@modusign/design-system';
import React from 'react';

export default function EmptyListLayout({ children }: { children: React.ReactNode }) {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      justifyContent="center"
      py={80}
      textAlign="center"
      width="100%"
    >
      {children}
    </Flex>
  );
}
